import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Intro from './Intro.jsx';

class Selection extends Component {
  state = {
    animate: ''
  };

  componentDidMount () {
    this.props.toggleInQuiz(true);
    this.props.updateResultsFooter(false);
    this.props.updateResultsRatings(false);
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  render () {
    return (
      <section className={'animate ' + this.state.animate}>
        {this.props.route === 'find-a-plan' && <Intro type='you' />}
        <div className='wrap'>
          <h3>Who’s the plan for?</h3>
          <ul className='user'>
            <li><Link to='/individuals/find-a-plan/start' className='me'><span>Just Me</span></Link></li>
            <li><Link to='/families/find-a-plan/start' className='family'><span>My Family</span></Link></li>
            <li><Link to='/small-business/find-a-plan/start' className='employer'><span>My Employees</span></Link></li>
          </ul>
        </div>
      </section>
    );
  }
}

Selection.propTypes = { // validate props expected
};

export default Selection;
